import { createContext, useContext, useEffect, useState, type ReactNode } from "react"
import type { AuthUser } from "@ezbatna/core/domain/models"
import { getContainer } from "./container"

interface AuthCtx {
  user: AuthUser | null
  isAdmin: boolean
  loading: boolean
  signIn: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
}

const AuthContext = createContext<AuthCtx>(null!)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthUser | null>(null)
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsub = getContainer().authRepository.authStateStream().subscribe(async (u) => {
      setUser(u)
      setIsAdmin(await getContainer().authRepository.isAdmin())
      setLoading(false)
    })
    return unsub
  }, [])

  const signIn = async (email: string, password: string) => {
    await getContainer().authRepository.signIn(email, password)
  }

  const signOutFn = async () => {
    await getContainer().authRepository.signOut()
  }

  return (
    <AuthContext.Provider value={{ user, isAdmin, loading, signIn, signOut: signOutFn }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
